import React from 'react';

import TEST_ID from './index.testid';
import { isNil } from 'ramda';
import type { Size } from '~/styles/constants';
import DebouncedInput from '../DebouncedInput';
import type { ThemeColor } from '~/theme/System/tokens/colorPalette';
import { type Props as InputProps } from '~/components/molecule/Input';

export type Props = {
  className?: string;

  /** Input's disabled state */
  disabled?: boolean;

  /** Initial value of the input */
  value?: string;

  /** Input placeholder */
  placeholder?: string;

  /** Size of the input */
  size?: Size;

  /** Label of the input */
  label?: { text?: React.ReactNode; color?: ThemeColor };

  loading?: boolean;

  /** Width of the input */
  width?: string;

  validation?: InputProps['validation'];

  externalErrors?: InputProps['externalErrors'];

  /** get access to input value */
  onInputChange: (text: string) => void;
};

const text = {
  placeholder: 'Zoek...',
  search: 'Zoek',
};

const SearchInput: React.FCC<Props> = ({
  disabled,
  placeholder,
  size,
  label,
  width,
  value,
  validation,
  externalErrors,
  loading,
  onInputChange,
}) => {
  const onSearch = (value: string) => {
    if (!isNil(value)) {
      onInputChange(value);
    }
  };

  return (
    <DebouncedInput
      width={width}
      onDebouncedChange={onSearch}
      name="search"
      type="search"
      placeholder={placeholder ?? text.placeholder}
      disabled={disabled}
      dataTestId={TEST_ID.INPUT}
      size={size}
      icon={{
        name: loading ? 'loading' : 'search',
        color: { group: 'secondary' },
      }}
      value={value}
      label={label}
      externalErrors={externalErrors}
      validation={validation}
    />
  );
};

export default SearchInput;
